export default {"src":"/_next/static/media/icon_footer_home_tungsten.039e045c.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};